import { Layout, Text, useLocalVariant } from "@draftkings/arena-web";
import * as React from "react";
import { myBetsContentStyles, myBetsHeaderStyles, myBetsWrapperStyles } from "./_localVariants";
export const MyBetsHeaderWithContent = React.memo(function MyBetsHeaderWithContent(props) {
    const { myBetsHeader, children } = props;
    const myBetsWrapperVariant = useLocalVariant("layout", myBetsWrapperStyles);
    const myBetsContentVariant = useLocalVariant("layout", myBetsContentStyles);
    const myBetsHeaderVariant = useLocalVariant("text", myBetsHeaderStyles);
    return React.createElement(Layout, { variant: myBetsWrapperVariant },
        React.createElement(Text, { variant: myBetsHeaderVariant, testId: "my-bets-header" }, myBetsHeader),
        React.createElement(Layout, { variant: myBetsContentVariant }, children));
});
//# sourceMappingURL=MyBetsHeaderWithContent.js.map